import { CART } from "../../actions";

const cartIdReducer = (state = null, action) => {
  switch (action.type) {
    case CART.CARTID:
      return action.cart_id;
    default:
      return state;
  }
};

export default cartIdReducer;
